import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertTriangle } from 'lucide-react';
export function WhyFailSection() {
  return <section className="py-24 px-6 bg-[#0f0f0f] border-y border-white/5" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <FadeIn data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-12 tracking-tight" data-id="element-134">
            POR QUÉ LO QUE PROBASTE NO FUNCIONÓ
            <span className="block text-xl md:text-2xl font-normal text-gray-500 mt-2" data-id="element-135">
              (Y no es culpa tuya)
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-136">
          <div className="space-y-6" data-id="element-137">
            <FadeIn delay={0.1} data-id="element-138">
              <p className="text-lg text-gray-300 mb-4" data-id="element-139">Quizá intentaste:</p>
            </FadeIn>
            {['Rutinas perfectas que duran 3 días', '“Motivación” que se apaga cuando la vida pega', 'Journaling, listas, apps, hacks', 'Detox extremo que te vuelve a rebotar peor'].map((item, i) => <FadeIn key={i} delay={0.2 + i * 0.1} direction="right" data-id="element-140">
                <div className="flex items-center gap-3 p-4 bg-white/5 border border-white/5 rounded-sm" data-id="element-141">
                  <div className="w-2 h-2 bg-red-500 rounded-full" data-id="element-142" />
                  <span className="text-gray-300 font-medium" data-id="element-143">{item}</span>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.4} className="flex flex-col justify-center" data-id="element-144">
            <div className="bg-red-900/10 border border-red-900/30 p-8 rounded-sm" data-id="element-145">
              <AlertTriangle className="w-10 h-10 text-red-500 mb-6" data-id="element-146" />
              <p className="text-xl font-bold text-white mb-4" data-id="element-147">
                Todo eso comparte un defecto:
              </p>
              <p className="text-2xl font-black text-red-500 mb-6 uppercase tracking-tight" data-id="element-148">
                Requiere que estés bien para funcionar.
              </p>
              <p className="text-lg text-gray-300" data-id="element-149">
                Y tú no estás comprando un método para los días perfectos.{' '}
                <br data-id="element-150" />
                <strong className="text-white" data-id="element-151">
                  Estás comprando uno para los días reales.
                </strong>
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}